// Tabs functionality with accessibility support
export function initTabs() {
    const tabContainers = document.querySelectorAll('.tabs-container');

    tabContainers.forEach((container) => {
        const tabs = container.querySelectorAll('[role="tab"]') as NodeListOf<HTMLButtonElement>;
        const panels = container.querySelectorAll('[role="tabpanel"]') as NodeListOf<HTMLElement>;

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                activateTab(tabs, panels, index);
            });

            tab.addEventListener('keydown', (e) => {
                let newIndex = index;

                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    newIndex = index + 1 >= tabs.length ? 0 : index + 1;
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    newIndex = index - 1 < 0 ? tabs.length - 1 : index - 1;
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    newIndex = 0;
                } else if (e.key === 'End') {
                    e.preventDefault();
                    newIndex = tabs.length - 1;
                }

                if (newIndex !== index) {
                    activateTab(tabs, panels, newIndex);
                    tabs[newIndex].focus();
                }
            });
        });
    });
}

function activateTab(
    tabs: NodeListOf<HTMLButtonElement>,
    panels: NodeListOf<HTMLElement>,
    activeIndex: number
) {
    // Deactivate all tabs and panels
    tabs.forEach((tab, index) => {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
        tab.classList.remove('active');
        panels[index]?.classList.remove('active');
        panels[index]?.classList.add('hidden');
    });

    // Activate selected tab and panel
    tabs[activeIndex].setAttribute('aria-selected', 'true');
    tabs[activeIndex].setAttribute('tabindex', '0');
    tabs[activeIndex].classList.add('active');
    panels[activeIndex]?.classList.add('active');
    panels[activeIndex]?.classList.remove('hidden');
}
